import {Navigate} from 'react-router-dom';

import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {communicationRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {EmailSynchronization} from './pages/EmailSynchronization/EmailSynchronization';

export const CommunicationModule: Module = {
  id: moduleKeys.communication,
  requiredFeatureFlag: featureFlags.MESSAGE_SYNCHRONIZATION,
  requiredPermission: permissions.syncedMessageRead,
  layoutProps: {
    title: 'page.customer.labels.communication',
    icon: 'communication/thread',
  },
  routerProps: {
    path: communicationRoutes.home,
    element: <Navigate to={communicationRoutes.emailSynchronization} replace />,
  },
  content: [
    {
      id: 'communication-email-synchronization',
      requiredFeatureFlag: featureFlags.MESSAGE_SYNCHRONIZATION,
      requiredPermission: permissions.syncedMessageRead,
      routerProps: {
        path: communicationRoutes.emailSynchronization,
        element: <EmailSynchronization />,
      },
    },
  ],
};
